import * as React from "react";
import * as ReactDOM from "react-dom";

import "azure-devops-ui/Core/override.css";
import "./index.scss";

import { setIsPublicSite, setPackageVersion, setProductName } from "./configuration";
import { setRootUrl } from "./routing";
import { applyTheme, currentUserTheme } from "./theming";

import { unregister } from "./registerServiceWorker";

import Shell from "./Components/Shell";

const rootElement = document.getElementById("root")!;

let redirectUrl: string | undefined;
const redirects = rootElement.getAttribute("data-redirects") || "";
if (redirects) {
    for (const redirectPair of redirects.split(";")) {
        const redirectSplits = redirectPair.split("|");
        if (redirectSplits.length === 2) {
            if (redirectSplits[0] === location.href) {
                redirectUrl = redirectSplits[1];
            }
        }
    }
}

if (redirectUrl) {
    location.href = redirectUrl;
} else {
    const rootUrl = rootElement.getAttribute("data-rootUrl") || "";
    setRootUrl(rootUrl);

    const productName = rootElement.getAttribute("data-productName") || "";
    setProductName(productName);

    const packageVersion = rootElement.getAttribute("data-packageVersion") || "";
    setPackageVersion(packageVersion);

    const isPublicSite = rootElement.getAttribute("data-isPublicSite") === "true";
    setIsPublicSite(isPublicSite);

    applyTheme(currentUserTheme.value);

    ReactDOM.render(<Shell />, rootElement);
    unregister();
}
